import ApiClient from '@/api/ApiClient';
import Country from '@/api/models/Country';
import BaseService from './BaseService';

class CountryService extends BaseService {
    #prefixUrl = 'api/country/';

    STORAGE_DEFINITION = {
        COUNTRIES_LIST: 'countryList',
    };

    constructor() {
        super();
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets all countries
     * @returns {Array}
     */
    async getCountries() {
        const response = await this.api.executeRequest('/index', {}, this.api.methods.GET);

        let countries = [];

        if (response.success()) {
            const data = response.getContent();
            
            for (let countryData of Object.keys(data)) {
                countries.push(new Country(data[countryData]));
            }
        }

        return countries;
    }
}

export default new CountryService();
